import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import portfolioData from '../data/portfolioData.json';
import '../styles/Pages.css';

import heroImage from '../assets/images/aboutHero.png';

export default function CompletedProjects({ onNavigate }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle both array and object data structures
  const projectsData = portfolioData && Array.isArray(portfolioData) ? portfolioData : portfolioData?.projects || [];
  const completedProjects = projectsData.filter(p => p.status === 'Completed');

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* HERO SECTION */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="container">
          <h1>Completed Projects</h1>
          <p>Excellence Delivered</p>
        </div>
      </section>

      {/* PROJECTS SHOWCASE SECTION */}
      <section className="projects-showcase">
        <div className="container">
          <div className="projects-grid">
            {completedProjects.map((project) => (
              <div key={project.id} className="project-card">
                {/* TAG */}
                <div className="project-tag">{project.type}</div>
                
                {/* TITLE */}
                <h3 className="project-title">{project.name}</h3>
                
                {/* DETAILS */}
                <div className="project-details">
                  {/* TYPE OF PROJECT */}
                  <div className="detail-row">
                    <span className="detail-icon">📋</span>
                    <div>
                      <span className="detail-label">Type of Project</span>
                      <span className="detail-value">{project.type}</span>
                    </div>
                  </div>

                  {/* CLIENT */}
                  <div className="detail-row">
                    <span className="detail-icon">👤</span>
                    <div>
                      <span className="detail-label">Client</span>
                      <span className="detail-value">{project.client}</span>
                    </div>
                  </div>

                  {/* VALUE OF WORK */}
                  <div className="detail-row">
                    <span className="detail-icon">₹</span>
                    <div>
                      <span className="detail-label">Value of Work</span>
                      <span className="detail-value">{project.value}</span>
                    </div>
                  </div>
                </div>

                {/* ARROW */}
                <div className="project-arrow">→</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <div className="container">
          <h2>Impressed by Our Track Record?</h2>
          <p>Let's discuss how we can deliver your next infrastructure project</p>
          <button 
            className="btn-primary"
            onClick={() => onNavigate('contact-us')}
          >
            Get in Touch
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}